exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect__input{\n  width:0px!important;\n}\n\n\n", ""]);

// exports
